export enum InvoiceStatus {
  'Pagado' = 1,
  'Cobrado' = 1,
  'Sin Pagar' = 0,
  'Sin Cobrar' = 0,
  'Cancelada' = 2,
}
